import { render } from "./LaunchEventView.vue?vue&type=template&id=f4b8fae4&scoped=true"
import script from "./LaunchEventView.vue?vue&type=script&lang=js"
export * from "./LaunchEventView.vue?vue&type=script&lang=js"

import "./LaunchEventView.vue?vue&type=style&index=0&id=f4b8fae4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4b8fae4"]])

export default __exports__